import React from 'react'
import "../Page_404/page_404.css"
import { useHistory } from "react-router-dom"

export const Page_404 = () => {
    const history = useHistory()
    return (
        <div className="container1">
            <div className="container404"></div>
            <button className="btn_home_404" onClick={() => {
                // localStorage.removeItem("navigate_404")
                history.goBack()
            }}>Go to Home</button>
        </div>
    )
}
